import { InjectionToken } from '@angular/core';

import { Environment } from '@digital-platform/ries-hub-shared/domain';

export const ENVIRONMENT = new InjectionToken<Environment>('environment');
